/**
 * Intro.js options default proptypes.
 * @type {Object}
 */
export const options = {
  hidePrev: true,
  hideNext: true,
};
